module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chapter2"
  }, [_vm._v("The Troubles of Glinda the Good")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "Book1/images/Baum-LostPrincess-scan015.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "chapter1"
  }, [_vm._v("Chapter 2")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("That same morning there was great excitement in the castle of the powerful Sorceress of Oz, Glinda the Good. This castle, situated in the Quadling Country, far south of the Emerald City where Ozma ruled, was a splendid structure of exquisite marbles and silver grilles. Here the Sorceress lived, surrounded by a bevy of the most beautiful maidens of Oz, gathered from all the four countries of that fairyland as well as from the magnificent Emerald City itself, which stood in the place where the four countries cornered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was considered a great honor to be allowed to serve the good Sorceress, whose arts of magic were used only to benefit the Oz people. Glinda was Ozma’s most valued servant, for her knowledge of sorcery was wonderful and she could accomplish almost anything that her mistress, the lovely girl Ruler of Oz, wished her to."), _c('a', {
    attrs: {
      "id": "page_11"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Of all the magical things which surrounded Glinda in her castle there was none more marvelous than her Great Book of Records. On the pages of this Record Book were constantly being inscribed—day by day and hour by hour—all the important events that happened anywhere in the known world, and they were inscribed in the book at exactly the moment the events happened. Every adventure in the Land of Oz and in the big outside world, and even in places that you and I have never heard of, were recorded accurately in the Great Book, which never made a mistake and stated only the exact truth. For that reason nothing could be concealed from Glinda the Good, who had only to look at the pages of the Great Book of Records to know everything that had taken place. That was one reason she was such a great Sorceress, for the records made her wiser than any other living person.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This wonderful book was placed upon a big gold table that stood in the middle of Glinda’s drawing-room. The legs of the table, which were incrusted with precious gems, were firmly fastened to the tiled floor and the book itself was chained to the table and locked with six stout golden padlocks, the keys to which Glinda carried on a chain that was secured around her own neck.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The pages of the Great Book were larger in size than those of an American newspaper and although they were exceedingly thin there were so many of them that they made an enormous, bulky volume. With its gold cover and gold clasps the book was so heavy that three men could scarcely have lifted it. Yet this morning, when Glinda entered her drawing-room after breakfast, with all her maidens trailing after her, the good Sorceress was amazed to discover that her Great Book of Records had mysteriously disappeared.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("Advancing to the table, she found the chains had been cut with some sharp instrument, and this must have been done while all in the castle slept. Glinda was shocked and grieved. Who could have done this wicked, bold thing? And who could wish to deprive her of her Great Book of Records?")]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('a', {
    attrs: {
      "id": "page_13"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "Book1/images/Baum-LostPrincess-scan016.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Sorceress was thoughtful for a time, considering the consequences of her loss. Then she went to her Room of Magic to prepare a charm that would tell her who had stolen the Record Book. But, when she unlocked her cupboards and threw open the doors, all of her magical instruments and rare chemical compounds had been removed from the shelves.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Sorceress was now both angry and alarmed. She sat down in a chair and tried to think how this extraordinary robbery could have taken place. It was evident that the thief was some person of very great power, or the theft could never have been accomplished without her knowledge. But who, in all the Land of Oz, was powerful and skillful enough to do this awful thing? And who, having the power, could also have an object in defying the wisest and most talented Sorceress the world has ever known?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Glinda thought over the perplexing matter for a full hour, at the end of which time she was still puzzled how to explain it. But although her instruments and chemicals were gone her "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("knowledge")]), _vm._v(" of magic had not been stolen, by any means, since no thief, however skillful, can rob one of knowledge, and that is why knowledge is the best and safest treasure to acquire. Glinda believed that when she had time to gather more magical herbs and elixirs and to manufacture more magical instruments she would be able to discover who the robber was, and what had become of her precious Book of Records.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Whoever has done this,” she said to her maidens, “is a very foolish person, for in time he is sure to be found out and will then be severely punished.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("She now made a list of the things she needed and dispatched messengers to every part of Oz with instructions to obtain them and bring them to her as soon as possible. And one of her messengers met the little Wizard of Oz, who was mounted on the back of the famous live Sawhorse and was clinging to its neck with both his arms; for the Sawhorse was speeding to Glinda’s")]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v(" castle with the velocity of the wind, hearing the news that Royal Ozma, Ruler of all the great Land of Oz, had suddenly disappeared and no one in the Emerald City knew what had become of her.")]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "Book1/images/Baum-LostPrincess-scan017.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Also,” said the Wizard, as he stood before the astonished Sorceress, “Ozma’s Magic Picture is gone, so we cannot consult it to discover where she is. So I came to you for assistance as soon as we realized our loss. Let us look in the Great Book of Records.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("“Alas,” returned the Sorceress sorrowfully, “we cannot do that, for the Great Book of Records has also disappeared!”")]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "Book1/images/Baum-LostPrincess-scan018.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-463621a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book1/xhtml/06_Chapter_2.vue
// module id = 81
// module chunks = 0